import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let timeLine = new Swiper(".line-content", {
        slidesPerView: 4,
        spaceBetween: 12,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 12,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 12,
            },
        },
        navigation: {
            nextEl: ".line-button-next",
            prevEl: ".line-button-prev",
        },
    });

    let gallerySlide = new Swiper(".gallery-slide", {
        slidesPerView: 1,
        autoplay: {
            delay: 4000,
        },
    });

    let videoSlide = new Swiper(".video-slide", {
        slidesPerView: 1,
        autoplay: {
            delay: 4000,
        },
    });
};
